<template>
  <form method="post">
    <div class="col-md-11 p-h-xs" >
      <div class="form-group">
        <redactor v-model="notification_content" type="text"  name="notification_content" class="col-md-10" placeholder="Content goes here.. " />
        <ladda-button
          class="btn btn-sm btn-success col-md-2"
          type="submit"
          :click="saveContents">
          Save
        </ladda-button>
        <ladda-button
          class="btn btn-sm btn-danger col-md-2"
          type="submit"
          :click="resetContents">
          Reset
        </ladda-button>
      </div>
    </div>
  </form>
</template>

<script>
import { http } from 'utils'
import { handleServerErrors } from 'utils/http'
import Redactor from 'codium-redactor'

export default {
  props: [
    'notificationTemplateId',
    'notificationOriginalContent',
    'notificationSavedContent',
    'emailTemplate',
    'partId'
  ],
  components: {
    Redactor
  },
  data () {
    return {
      notification_content: this.notificationSavedContent === '' ? this.notificationOriginalContent : this.notificationSavedContent
    }
  },

  methods: {
    saveContents () {
      return this.validate()
        .then(() => {
          const params = {
            notificationTemplateId: this.notificationTemplateId,
            notificationContent: this.notification_content,
            emailTemplate: this.emailTemplate,
            partId: this.partId,
            type: 'mail'
          }

          return http.post(`email-notification-content`, params).then((response) => {
            if (response.data === 1) {
              this.$parent.handleAddManagerCallback()
            } else {
              throw new Error('Error saving template')
            }
          })
        }).catch((error) => {
          if (error.response && error.response.status === 422) {
            handleServerErrors(error, this.errors)
          } else {
            throw error
          }
        })
    },
    resetContents () { // TODO: merge into one method
      return this.validate()
        .then(() => {
          const params = {
            notificationTemplateId: this.notificationTemplateId,
            partId: this.partId
          }

          return http.post(`email-notification-content-reset`, params).then((response) => {
            if (response.data === 1) {
              this.notification_content = this.notificationOriginalContent
              this.$parent.handleAddManagerCallback()
            } else {
              throw new Error('Error resetting template')
            }
          })
        }).catch((error) => {
          if (error.response && error.response.status === 422) {
            handleServerErrors(error, this.errors)
          } else {
            throw error
          }
        })
    }
  }
}
</script>
